import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumb, MenuAccount, Pagination } from '../../../components/Main'
import { Link } from 'react-router-dom'
import WideCardOrderShipping from '../../../components/widecard/WideCardOrderShipping'
import InteractorShippingHeaderSearch from '../../../interactors/transaction/shipping/InteractorShippingHeaderSearch'
import { useSelector } from 'react-redux'

const OrderShippingIndex = () => {
  const pathSegments = window.location.pathname.split('/')
  const uid = pathSegments[pathSegments.length - 1]
  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)
  const { shippingHeaderSearch } = InteractorShippingHeaderSearch()
  const [loading, setLoading] = useState(true)
  const [download] = useState({
    headers: null,
    items: null,
    filename: null,
  })
  const [datacard, setDatacard] = useState([])
  const [payload, setPayload] = useState({
    page: 1,
    limit: 50,
    keywords: {
      text_search: '',
      uid: '',
      transaction_uid: uid,
      account_uid: account?.uid,
      status: '',
      store_uid: '',
    },
  })

  const handleResponse = useCallback((data) => setDatacard(data), [])

  const handleFilter = (row) => {
    setPayload(row)
    setDatacard([])
    setLoading(true)
  }

  const handlePageChange = (page) => {
    setPayload((prev) => ({ ...prev, page }))
    setLoading(true)
  }

  const handleLimitChange = (limit) => {
    setPayload((prev) => ({
      ...prev,
      page: 1,
      limit: Number(limit),
    }))
    setLoading(true)
  }

  useEffect(() => {
    if (loading) {
      shippingHeaderSearch(payload, handleResponse, setLoading)
    }
  }, [shippingHeaderSearch, handleResponse, loading, payload])

  return (
    <>
      <Breadcrumb title={t('menu.order_shipping')} className="mb-4" />
      <div className="container">
        <div className="row mb-8">
          <MenuAccount />
          <div className="col-xl-9 col-wd-9gdot5">
            <div className="flex-center-between mt-2 mt-0-lg">
              <h3 className="font-size-20 font-size-20-lg font-weight-bold mb-0">
                {t('menu.order_shipping')}{' '}
                {datacard?.items?.length > 0 && datacard?.items[0]?.transaction_code}
              </h3>
              <Link
                to={'#'}
                onClick={() => {
                  window.location = `/order/view/${uid}`
                }}
                className="text-dark btn-outline-secondary btn btn-xs m-2 font-size-12"
              >
                <i className="fas fa-arrow-left px-2"></i> {t('button.back')}
              </Link>
            </div>
            <hr />
            <WideCardOrderShipping
              loading={loading}
              datacard={datacard}
              payload={payload}
              handleFilter={handleFilter}
              download={false}
            />
            <Pagination
              data={datacard.pages}
              onChangePage={handlePageChange}
              onLimitChange={handleLimitChange}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderShippingIndex
